import { EvaluationTaskStatusEnum } from "../../../features/evaluation-tasks/models/enums/EvaluationTaskStatusEnum"

export class AvailableActions {
  actions: Action[]
  messages: { message: string , image:string}[]
}

export class Action {
  currentStatus: string
  nextStatus: EvaluationTaskStatusEnum
  class: any
  title: string
  actionId: number
  apiName: string
}
